module.exports = __webpack_public_path__ + "static/media/atlanta.3facc67f.jpg";